// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraWindowBase } from './TerceraWindowBase';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
export class MainWindowBase extends TerceraWindowBase {
    oninit() {
        super.oninit();
        MainWindowManager.MainWindow = this;
    }
}
